export class HtaMetadata {
  title?: string
  abstract?: string
  authors?: string[]
  doi?: string
  publishYear?: string
  potentialPdfUrl?: string
  issueNumber?: string
  journal?: string
  pagesNumber?: string

  constructor(data: {
    title?: string
    abstract?: string
    authors?: string[]
    doi?: string
    publishYear?: string
    potentialPdfUrl?: string
    issueNumber?: string
    journal?: string
    pagesNumber?: string
  }) {
    this.title = data.title
    this.abstract = data.abstract
    this.authors = data.authors
    this.doi = data.doi
    this.publishYear = data.publishYear
    this.potentialPdfUrl = data.potentialPdfUrl
    this.issueNumber = data.issueNumber
    this.journal = data.journal
    this.pagesNumber = data.pagesNumber
  }
}
